
import { NgModule } from '@angular/core';
import { MatIconModule, } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { SortingArrowModule } from '../sorting-arrow/sorting-arrow.module';
import { SortingMenuComponent } from './sorting-menu.component';



@NgModule({
  declarations: [
    SortingMenuComponent,
  ],

  imports: [
    CommonModule,
    SortingArrowModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule
  ],

  exports: [
    SortingMenuComponent,
  ],

  providers: [ ],

})

export class SortingMenuModule { }
